import { useState } from 'react'

import { useBrand } from '~/brand'
import { useAppDepsContext } from '~/core/hooks/useAppDepsContext'
import { DownloadContractResponse } from '~/offersConfigurator/services/downloadContract.service'

interface StateInterface {
  data?: DownloadContractResponse
  loading: boolean
  error?: string
}

const InitialState = {
  loading: false,
}

export default function useDownloadContract() {
  const { downloadContractService } = useAppDepsContext()
  const { brand } = useBrand()

  const [state, setState] = useState<StateInterface>(InitialState)

  function isInitialState() {
    return state.loading === false && !state.data && !state.error
  }

  function downloadContract(subscriptionId?: string, accountId?: string) {
    setState({ ...InitialState, loading: true })

    downloadContractService
      .downloadContract({ brand, subscriptionId, accountId })
      .then((result: DownloadContractResponse) => {
        const binaryString = window.atob(result.contract)
        const len = binaryString.length
        const bytes = new Uint8Array(len)
        for (let i = 0; i < len; i += 1) {
          bytes[i] = binaryString.charCodeAt(i)
        }
        const fileBlob = new Blob([bytes.buffer], { type: 'application/pdf' })

        // For Internet Explorer
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(fileBlob)
          return
        }

        const fileURL = URL.createObjectURL(fileBlob)
        window.open(fileURL)

        setState({ ...InitialState, loading: false, data: result })
      })
      .catch((error: string) => {
        setState({ ...InitialState, loading: false, error })
      })
  }

  return {
    downloadContractState: state,
    contract: state.data || [],
    isInitialState,
    downloadContract,
    cleanDownloadContractError: () => setState({ ...state, error: undefined }),
  }
}
